module.exports = __webpack_public_path__ + "static/media/support_icon.b02074f8.svg";